import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  lock(event) {
    const button = this.element.querySelector("[data-publish-classifica-target='button']")
    if (!button) return

    const label = button.querySelector("[data-publish-classifica-target='label']")
    const spinner = button.querySelector("[data-publish-classifica-target='spinner']")

    button.disabled = true
    if (label) label.textContent = "Generazione in corso..."
    if (spinner) spinner.classList.remove("d-none")
  }
}
